import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { post } from "../../lib/request";

export const likeMessageApi = createAsyncThunk(
  "messageLike/like",
  async ({ messageId, channel }, { rejectWithValue }) => {
    try {
      await post(`${channel}/messages/${messageId}/like`, {
        headers: { accept: "*/*" },
      });
      return { messageId, channel };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const unlikeMessageApi = createAsyncThunk(
  "messageLike/unlike",
  async ({ messageId, channel }, { rejectWithValue }) => {
    try {
      await post(`${channel}/messages/${messageId}/unlike`, {
        headers: { accept: "*/*" },
      });
      return { messageId, channel };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

const messageLikeSlice = createSlice({
  name: "messageLike",
  initialState: {
    likedMessageIds: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(likeMessageApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(likeMessageApi.fulfilled, (state, action) => {
        state.loading = false;
        const { messageId } = action.payload;
        if (!state.likedMessageIds.includes(messageId)) {
          state.likedMessageIds.push(messageId);
        }
      })
      .addCase(likeMessageApi.rejected, (state) => {
        state.loading = false;
      })
      .addCase(unlikeMessageApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(unlikeMessageApi.fulfilled, (state, action) => {
        state.loading = false;
        const { messageId } = action.payload;
        state.likedMessageIds = state.likedMessageIds.filter(
          (id) => id !== messageId
        );
      })
      .addCase(unlikeMessageApi.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default messageLikeSlice.reducer;
